<template>
  <div
    class="m-grid m-grid--hor m-grid--root m-page"
    style="height: 100%"
  >
    <div
      id="m_login"
      class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin"
    >
      <div
        class=" b m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-login__content m-grid-item--center"
        :style="'background: url('+cdnURL+'/img/bg/bg-login.jpg) no-repeat center center / COVER'"
      >
        <div
          id="login-form-container"
          class="m-grid__item text-center p-4"
        >
          <router-link
            to="/"
          >
            <img
              alt="thinkSPAIN"
              :src="cdnURL+'/img/logos/white.png'"
              width="250px"
            >
            <p class="m-login__msg mb-2">
              {{ $t('app.name') }}
            </p>
          </router-link>
          <div
            id="language-picker"
            class="p-2"
          >
            <button
              type="button"
              :class="{'btn p-0 d-flex mr-2':true,'active':isActiveLanguage('en')}"
              :title="$t('lang.en')"
              @click="setLocale('en')"
            >
              {{ $t('lang.en') }}
            </button>
            <button
              type="button"
              :class="{'btn p-0 d-flex':true,'active':isActiveLanguage('es')}"
              :title="$t('lang.es')"
              @click="setLocale('es')"
            >
              {{ $t('lang.es') }}
            </button>
          </div>
          <form
            class="m-login__form m-form"
            style="width: 400px; max-width: 100%;"
            @submit.prevent="resetPassword"
          >
            <div v-if="!showSuccessMsg">
              <div :class="{'form-group m-form__group mt-3':true, 'has-success': hasClientID}">
                <input
                  v-model="clientID"
                  class="form-control m-input"
                  type="text"
                  :placeholder="$t('Login.login')"
                  autocomplete="off"
                  required
                  :disabled="loading"
                >
              </div>
              <div class="m-login__form-action">
                <button
                  id="m_login_signin_submit"
                  type="submit"
                  class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air w-100 font-weight-bold"
                  :disabled="loading || !canSubmit"
                >
                  {{ $t(submitTranslationKey) }}
                </button>
              </div>
            </div>
            <div
              v-if="showSuccessMsg"
              class="alert alert-light text-primary font-weight-bold mt-4"
            >
              {{ successMsg }}
            </div>
            <router-link
              to="/"
              class="btn btn-link mt-2 font-weight-bold text-white"
            >
              <i class="la la-chevron-left" />
              {{ $t('Login.backToLogin') }}
            </router-link>
            <p
              id="forgot-details-text"
              class="mb-0 mt-4 text-white"
              v-html="$t('Login.forgotClientID')"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onBeforeOpenSwal, clearAuthCookies, checkIfEmail } from '../../functions.ts';
import authapi from '../../api-clients/auth-api.js';
import { adminauthapiwithoutrefresh } from '../../api-clients/admin-auth-api.js';
import Cookie from 'js-cookie';

export default {
    name: 'RequestPasswordReset',
    data() {
        return {
            cdnURL: import.meta.env.TWC_CDN_URL,
            clientID: '',
            clientEmail: '',
            showSuccessMsg: false,
            successMsg: '',
            loading: false,
        };
    },
    computed: {
        hasClientID() {
            return this.clientID.length > 0;
        },
        hasProvidedEmail() {
            return !!this.clientEmail && this.clientEmail.length > 0;
        },
        hasValidEmail() {
            return this.hasProvidedEmail && checkIfEmail( this.clientEmail );
        },
        canSubmit() {
            return this.hasClientID;
        },
        isSetPasswordFlow() {
            const metaMode = this.$route.meta && this.$route.meta.mode;
            return metaMode === 'set' || this.$route.name === 'RequestSetPassword';
        },
        submitTranslationKey() {
            return this.isSetPasswordFlow ? 'Login.setPassword' : 'Login.resetPassword';
        },
    },
    async mounted() {
        this.loading = true;
        clearAuthCookies();

        const query = this.$route.query || {};
        const params = this.$route.params || {};

        const clientIDFromQuery = typeof query.clientID === 'string' ? query.clientID : null;
        const clientIDFromParams = typeof params.clientID === 'string' ? params.clientID : null;

        const initialClientID = clientIDFromQuery || clientIDFromParams;

        if ( this.$route.meta.mode === 'set' && !initialClientID ) {
            this.loading = false;
            await this.$router.replace( '/' );
            return;
        }

        if ( initialClientID ) {
            this.clientID = initialClientID;
        }

        if ( this.$route.meta.mode === 'set' && initialClientID ) {
            const r = await authapi.post( '/client/auth/status', {
                clientID: initialClientID,
            } );

            if ( r.status !== 200 ) {
                let codeTerm = 'error.server.ErrUnknown';

                if ( res.data && res.data.code ) {
                    codeTerm = `error.server.${res.data.code}`;
                }

                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( codeTerm ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                this.loading = false;
                return;
            }

            if ( r.data.status !== 'requires_password_set' ) {
                await this.$router.replace( '/?clientID=' + this.clientID );
            }
        }

        this.loading = false;
    },
    methods: {
        async resetPassword() {
            this.loading = true;

            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            const endpoint = this.isSetPasswordFlow ?
                '/client/auth/request-set' :
                '/client/auth/request-reset';

            const res = await adminauthapiwithoutrefresh.post(
                endpoint,
                {
                    clientID: this.clientID,
                    lang: this.$i18n.locale === 'en' ? 'en' : 'es',
                },
            );

            if ( res.status !== 200 ) {
                mApp.unblock( 'body' );
                this.loading = false;

                let codeTerm = 'error.server.ErrUnknown';

                if ( res.data && res.data.code ) {
                    codeTerm = `error.server.${res.data.code}`;
                }

                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( codeTerm ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.showSuccessMsg = true;

            const successKey = res.data.email ?
                ( this.isSetPasswordFlow ?
                    'Login.setPasswordRequestSuccessMsg' :
                    'Login.resetPasswordRequestSuccessMsg' ) :
                ( this.isSetPasswordFlow ?
                    'Login.setPasswordRequestSuccessMsgNoEmail' :
                    'Login.resetPasswordRequestSuccessMsgNoEmail' );

            this.successMsg = res.data.email ?
                this.$t( successKey, { email: res.data.email } ) :
                this.$t( successKey );

            mApp.unblock( 'body' );

            this.loading = false;
        },
        setLocale( locale ) {
            Cookie.set( 'locale', locale, { expires: 14,
                sameSite: 'Strict' } );
            this.$i18n.locale = locale;
        },
        isActiveLanguage( codeLang ) {
            return this.$i18n.locale === codeLang;
        },
    },
};
</script>
<style lang="scss">
  #forgot-details-text a {
      text-decoration: underline;
  }

  #login-form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);

    @media screen and (max-width: 575px) {
      height: 100vh;
    }
  }

  #language-picker {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    border-radius: 50px;
    width: fit-content;
    margin: 0 auto;

    button {
      position: relative;
      color: #fff;
      font-weight: 500;

      &:hover,
      &.active {
        text-decoration: underline;
      }
    }
  }

  .form-group {
    input {
      border-top: none;
      border-bottom: none;
      border-right: none;

      &:focus {
        border-left: none;
      }
    }

    &.has-success {
      input {
        border-left: 10px solid #34bfa3 !important;
      }
    }

    &.has-error {
      input {
        border-left: 10px solid #da4d51 !important;
      }
    }
  }
</style>
